module.exports = new __parcel__URL__("greenBar.869cd775.svg").toString();